import React from 'react';
import TituloPisoPvcRigido from '../components/sections/PisoDePvcRigido/TituloPisoPvcRigido'; 
import IntroPisoDePvcRigido from '../components/sections/PisoDePvcRigido/IntroPisoDePvcRigido'; 
import CatalogoPisoDePvcRigido from '../components/sections/PisoDePvcRigido/CatalogoPisoDePvcRigido'; 
import FormularioContactoPvcRigido from '../components/sections/PisoDePvcRigido/FormularioContactoPvcRigido'; 
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const PisoDePvcRigido = () => {
  return (
    <div>
      <Header />
        <TituloPisoPvcRigido />  
        <IntroPisoDePvcRigido /> 
        <CatalogoPisoDePvcRigido /> 
        <FormularioContactoPvcRigido />
      <Footer />
    </div>
  );
};

export default PisoDePvcRigido;